import { Link, Outlet } from "react-router-dom"
import { AppConfig } from "~/common/app-config"
import { rootPath } from "~/common/paths"
import wordmarkUrl from "~/images/wp-mascot-wordmark.png"

const LOGIN_HERO_IMAGE =
  "https://images.pexels.com/photos/1586950/pexels-photo-1586950.jpeg?auto=compress&cs=tinysrgb&w=1260&h=1600&dpr=2"

export const LoginLayout = () => {
  return (
    <div className="flex min-h-screen flex-col bg-stone-50">
      <div className="flex flex-grow flex-col items-center justify-center px-4 py-8 lg:flex-row lg:gap-0 lg:px-8 lg:py-12">
        <div
          className="hidden bg-stone-200 lg:block lg:h-[720px] lg:w-[560px] lg:rounded-l-[32px]"
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(28,25,23,0.20) 0%, rgba(28,25,23,0.55) 100%), url(${LOGIN_HERO_IMAGE})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          aria-hidden
        />

        <div className="flex w-full max-w-md flex-col items-center justify-center rounded-2xl bg-background px-6 py-10 shadow-sm sm:px-10 lg:h-[720px] lg:w-[480px] lg:max-w-none lg:rounded-l-none lg:rounded-r-[32px] lg:px-10 lg:shadow-none">
          <div className="flex w-full max-w-sm flex-col items-center">
            <Link to={rootPath({})} className="mb-8 inline-block">
              <img src={wordmarkUrl} alt={AppConfig.app_name} className="h-56 w-auto sm:h-64" />
            </Link>
            <div className="w-full">
              <Outlet />
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 pb-5 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} {AppConfig.app_name}. All rights reserved.
      </div>
    </div>
  )
}
